import { NestedHome } from '@habity/types';
import { CommonEstateRoom } from '@habity/types/vitec/common/commonEstateRoom';
import {
  isCondominium,
  isCottage,
  isHouse,
  isHousingCooperative,
} from '@habity/types/vitec/assertions';
import { HomeDataBuilder } from './data-builder';
import { createRoomsFields } from './rooms-fields';

export const mapRoomDescriptions = (home: NestedHome) => {
  const { provider_data, provider_type } = home || {};
  if (!provider_data || !provider_type) return [];

  const data: CommonEstateRoom[] = [];

  if (
    isHouse(provider_data, provider_type) ||
    isCottage(provider_data, provider_type)
  ) {
    // @ts-ignore
    const { houseInterior } = provider_data || {};
    const { rooms } = houseInterior || {};
    return rooms;
  }

  if (
    isHousingCooperative(provider_data, provider_type) ||
    isCondominium(provider_data, provider_type)
  ) {
    const { interior } = provider_data || {};
    const { rooms } = interior || {};
    return rooms;
  }

  return data;
};

export const getRoomsData = (home: NestedHome) => {
  const context = { home };
  const roomsFields = createRoomsFields(context);

  return new HomeDataBuilder().withFields(roomsFields).build({ home });
};

export const getRoomsDescription = (home: NestedHome) => {
  const { rooms } = home?.address || {};
  rooms ? `${rooms} rum och kök` : '';
};
